import { render } from "./EmbedTestPage.vue?vue&type=template&id=6257b555&scoped=true"
import script from "./EmbedTestPage.vue?vue&type=script&lang=js"
export * from "./EmbedTestPage.vue?vue&type=script&lang=js"

import "./EmbedTestPage.vue?vue&type=style&index=0&id=6257b555&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6257b555"]])

export default __exports__